import classNames from 'classnames';
import React, { JSX } from 'react';
import { styled } from '@mui/material/styles';
import { fontSecondaryOblique } from 'src/theme/mixins';

type IModalItemProps = {
	text: string;
	icon?: JSX.Element;
} & JSX.IntrinsicElements['div'];

export const Item = styled(
	({ text, icon, className, children, ...props }: IModalItemProps) => {
		return (
			<div className={classNames('list__item', className)} {...props}>
				{icon && <span className="icon">{icon}</span>}
				{children}
				<span>{text}</span>
			</div>
		);
	},
	{
		target: 'Item-root',
		label: 'Item',
	},
)({
	display: 'flex',
	alignItems: 'center',
	padding: '0.5em 1em',
	...fontSecondaryOblique,
	fontSize: '1em',
	'& span': {
		color: 'var(--chat__modal__list__item_color)',
	},
	transition: 'all 150ms',
	'&:hover': {
		cursor: 'pointer',
		backgroundColor: 'var(--chat__modal__list__item--hover_background)',
	},

	'& .icon': {
		height: '18px',
		width: '18px',
		marginRight: '5px',
		display: 'flex',
		alignItems: 'center',

		'& svg': {
			height: '100%',
			width: 'auto',
			stroke: 'var(--chat__modal__list__item__icon_color)',
		},
	},
});
